import PopUp from '@/common/components/PopUp';
import React from 'react';
import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import { Header, SureButtonsWrapper } from './AreYouSure.styled';

const AreYouSure = ({ setShow, next }) => {
	return (
		<PopUp setShow={setShow}>
			<Header>Are you sure?</Header>
			<SureButtonsWrapper>
				<ActionButton
					buttonType='secondary'
					color={Colors.green}
					onClick={() => next()}
					defaultText='Yes'
				/>
				<ActionButton
					buttonType='secondary'
					color={Colors.red}
					defaultText='No'
					onClick={() => setShow(false)}
					background={Colors.red}
				/>
			</SureButtonsWrapper>
		</PopUp>
	);
};

export default AreYouSure;
